// @flow

import styled, { css } from 'styled-components';

export const Text = styled.p`
  color: black;

  ${props => props.flavor === 'secondary' && css`
    color: ${props => props.theme.colors.secondary(32)};
  `}

  ${props => props.flavor === 'info' && css`
    color: ${props => props.theme.colors.secondary(30)};
  `}

  ${props => props.center && css`
    text-align: center;
  `}

  ${props => props.bold && css`
    font-weight: bold;
  `}

  ${props => props.size === 'small' && css`
    font-size: 0.9em;
  `}

  ${props => props.size === 'md' && css`
    font-size: 1.5em;
  `}
  
  ${props => props.border === 'top' && css`
    border-top: 2px solid black;
    width: limited;
    align-self: center;
  `}
  
`;
